import React from 'react'
import ErrorHandler from '@strata-monorepo/shared-ui/components/atoms/ErrorHandler'
import { QuestionnaireHeader } from '../components/QuestionnaireHeader'

const ErrorStep: React.FC<{ onError: () => void }> = ({ onError }) => {
  const goToStrata = () => {
    // TODO: Implement needed metrics & eventing handling before calling callback
    onError()
  }

  return (
    <div className='strata:min-h-screen'>
      <QuestionnaireHeader />
      <div className='strata:mt-6 strata:@qm/qc:mt-24'>
        <ErrorHandler handleCTA={goToStrata} />
      </div>
    </div>
  )
}

export default ErrorStep
